import  * as React from "react";
import { observer } from "mobx-react";
import { IAverageMarkerProps } from "./IAverageMarkerProps";


@observer
export class AverageMarker extends React.Component<IAverageMarkerProps>{
    constructor(props: IAverageMarkerProps) {
        super(props, undefined);
    }
    render() {
        return <g className="AverageMarker">
                   <line x1={this.props.x1} y1={this.props.y1} x2={this.props.x2} y2={this.props.y2}/>
                   <text x={this.props.x2 + 9} y={this.props.y2 + 4}>{this.props.averageScore.toFixed(1)}</text>
               </g>;
    }
}
